<template>
	<div class="choose-language-popup">

		<div class="choose-language-dialog" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="400">
			<img src="@/drc/assets/icons/x_white.svg" @click="closeDialog" alt="close-icon">
			<div class="error-report-container">
				<h3>
					<img class="wave-hand-icon" src="@/common/assets/icons/waving-hand.svg" alt="wave-hand-icon">
					{{ $t('common.welcome') }}
				</h3>
				<span>{{$t('common.welcomeText')}}</span>
				<CommonSelect
					:form-data="formData"
					field="country"
					:label="$t('common.country')"
					:placeholder="$t('common.countryPlaceholder')"
					:options="dropdownData.countries"
					text-field-name="name"
					:errorLabel="$t('common.countryError')"
					imageUrl="common/assets/icons/countries/"
					:isMultiple="false"
					@selectedOption="checkError"
				/>
				<div v-if="formSubmittedEmpty" class="form-empty-warning">{{$t('common.countryError')}}</div>
				<div class="buttons-container">
					<button class="cancel-button button" @click="closeDialog">
<!--						{{ $t('common.confirmAndClose') }}-->
						{{ $t('common.cancel') }}
					</button>
					<button class="submit-language-button button"
									@click="handleMessage">
<!--						{{  $t('common.startTour') }}-->
						{{ $t('common.submit') }}
					</button>
				</div>
			</div>
		</div>

		<div @click="closeDialog"></div>
	</div>
</template>
<script>
import CommonSelect from "@/drc/pages/submit-form/components/CommonSelect.vue";

export default {
	name: "GopChooseLanguage",
	components: {CommonSelect},
	data() {
		return {
			sending: false,
			formSubmittedEmpty: false,
			isTextAreaInFocus: false,
			userMessage: "",
			doShowInputErrorMessage: false,
			formData: {
				country: {
					ref: null,
					value: [],
					errors: [],
					validations: []
				},
			},
			dropdownData:{
				countries:[],
			},
		}
	},
	mounted() {
		this.dropdownData.countries = this.$store.getters.getCommonField('deliveryCountries');
		if(this.$store.getters.getUser.gopUserCountry?.id){
			this.formData.country.value = [this.dropdownData.countries.find(el => el.id === this.$store.getters.getUser.gopUserCountry?.id)]
		}
	},
	methods: {
		checkError(){
			if(this.formData.country.value.length > 0){
				this.formData.country.errors = [];
				this.formSubmittedEmpty = false;
			}
		},
		closeDialog() {
			this.$emit('closeDialog');
		},
		handleMessage() {
			if(this.formData.country.value.length === 0){
				this.formSubmittedEmpty = true;
			}else{
				this.formSubmittedEmpty = false;
				this.$emit('submit', this.formData);
			}

		},
	}
}
</script>
<style lang="scss">
@import "@/common/assets/css/_variables.scss";
.choose-language-popup {
	text-align: left;
	.choose-language-dialog div div.generic-select {
		margin-top: 16px;
		margin-bottom: 16px;
		.label-holder label{
			color: $gop-new-blue !important;
			font-family: Roboto;
			font-weight: 400;
			font-size: 14px;
			leading-trim: NONE;
			line-height: 20px;

		}
		.options-container{
			.selected-options{
				.selected-tag{
					background: $gop-new-grey !important;
					.option-name{
						color:white;
					}
				}
			}
		}
		.dropdown-container{
			.dropdown-activator{
				border: 1px solid #E5E5EA !important;
			}
			.dropdown-options {
				scrollbar-color: #007A7A #E5E5EA !important;
			}
		}
	}
	.choose-language-dialog div div.image-upload-container {
		div.image-uploader label.uploader-section{
			background: #F2F2F7 !important;
		}
		div.hint label{
			color: #001f33 !important;
		}
	}


}
</style>
<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.choose-language-popup {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: calc(#{30} - 2); // (x-2), because (x-1) is the z-index for sidebar background
	display: flex;
	justify-content: center;

	.textarea-container{
		label{
			font-family: Roboto;
			font-weight: 600;
			font-size: 17px;
			line-height: 22px;
			letter-spacing: 0px;
			color: #001F33;
		}
		textarea{
			font-family: Roboto;
			font-weight: 400;
			font-size: 16px;
			line-height: 21px;
			letter-spacing: 0px;
			background: #FFFFFF;
			height: 106px;
			padding: 16px;
			border: 1px solid #E5E5EA;
			border-radius: 0px;
			color: black;
			margin-top:8px;
			resize: none;
		}
	}

	& > div:nth-child(2) {
		height: 100vh;
		width: 100vw;
		background-color: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		cursor: pointer;
	}
}

.choose-language-dialog {
	overflow: visible;
	max-width: 688px;
	margin: 10vh 5px 0 5px;
	background-color: white;
	position: relative;
	width: 90%;
	cursor: default;
	max-height: 90vh;

	@media (max-width: 768px) {
		margin-top: 80px
	}

	.error-report-container{
		.form-empty-warning{
			color:red;
			text-align: right;
			margin-bottom: -25px;
		}
		.buttons-container{
			display: flex;
			justify-content: space-between;
			margin-top: 32px;
			gap: 12px;
			margin-bottom: 32px;
			.button {
				border-radius: 4px;
				background: #FFFFFF;
				width: 100%;
				height: 54px;
				border: none;
				font-family: Roboto;
				font-weight: 400;
				font-size: 17px;
				line-height: 22px;
				letter-spacing: 0px;
				text-align: center;
				border: 1px solid $gop-new-grey;
				cursor: pointer;
				background: $gop-new-white;
				color: $gop-new-grey;
				&.submit-language-button {
					background: $gop-new-grey;
					color: $gop-new-white

				}
			}
		}
	}

	& > img {
		position: absolute;
		top: 5px;
		right: 5px;
		height: 18px;
		width: 18px;
		margin: 23px 23px 0 0;
		cursor: pointer;
	}

	& > div {
		margin: 0 64px;

		@media screen and (max-width: 768px) {
			margin: 0 40px;
		}
		@media screen and (max-width: 375px) {
			margin: 0 20px;
		}
	}

	& > div > h3 {
		padding-top: 2px;
		letter-spacing: 0.36px;
		color: $gop-new-blue;
		font-family: Tiempos Text;
		font-weight: 400;
		font-size: 20px;
		line-height: 28px;
		& img{
			margin-top: -4px;
		}
	}

	& > div > span {
		letter-spacing: 0px;
		color: $gop-new-grey-text;
		font-family: Roboto;
		font-weight: 400;
		font-size: 16px;
		leading-trim: NONE;
		line-height: 24px;
	}
}

.submit-language {
	&.sending {
		background: #F3D592;
	}

	&:disabled {
		cursor: not-allowed;
	}

	img {
		margin-bottom: 2px;
		width: 20px;
		animation: rotateLoading 3s linear infinite;
	}
}

@keyframes rotateLoading {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
